/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PermissionDefinitionDto } from '../models';
// @ts-ignore
import type { RoleAccessDto } from '../models';
// @ts-ignore
import type { UpdateRolePermissionsRequestDto } from '../models';
// @ts-ignore
import type { UpdateUserAccessRequestDto } from '../models';
// @ts-ignore
import type { UserAccessDto } from '../models';
// @ts-ignore
import type { UserRoleDto } from '../models';
/**
 * RestAdministrationApi - axios parameter creator
 */
export const RestAdministrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Wszystkie uprawnienia w kolejności menu, z polską nazwą i kategorią. Tylko dla roli ADMIN. 
         * @summary Katalog uprawnień
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Każda rola z jej uprawnieniami i liczbą osób. ADMIN ma zawsze komplet i nie da się go edytować. Tylko dla roli ADMIN. 
         * @summary Uprawnienia ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wszystkie konta poza systemowym: rola, aktywność, dodatkowe i efektywne uprawnienia. Tylko dla roli ADMIN. 
         * @summary Dostęp użytkowników
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pełna podmiana uprawnień roli. Rola ADMIN → 400. Tylko dla roli ADMIN. 
         * @summary Podmiana uprawnień roli
         * @param {UserRoleDto} role 
         * @param {UpdateRolePermissionsRequestDto} updateRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminRolePermissions: async (role: UserRoleDto, updateRolePermissionsRequestDto: UpdateRolePermissionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('updateAdminRolePermissions', 'role', role)
            // verify required parameter 'updateRolePermissionsRequestDto' is not null or undefined
            assertParamExists('updateAdminRolePermissions', 'updateRolePermissionsRequestDto', updateRolePermissionsRequestDto)
            const localVarPath = `/api/admin/roles/{role}/permissions`
                .replace('{role}', encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRolePermissionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pełna podmiana roli, aktywności i dodatkowych uprawnień konta. Nie można zdjąć sobie roli ADMIN ani dezaktywować własnego konta (400); konto systemowe → 400; brak konta → 404. Tylko dla roli ADMIN. 
         * @summary Podmiana dostępu użytkownika
         * @param {string} userId 
         * @param {UpdateUserAccessRequestDto} updateUserAccessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminUserAccess: async (userId: string, updateUserAccessRequestDto: UpdateUserAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateAdminUserAccess', 'userId', userId)
            // verify required parameter 'updateUserAccessRequestDto' is not null or undefined
            assertParamExists('updateAdminUserAccess', 'updateUserAccessRequestDto', updateUserAccessRequestDto)
            const localVarPath = `/api/admin/users/{userId}/access`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAdministrationApi - functional programming interface
 */
export const RestAdministrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAdministrationApiAxiosParamCreator(configuration)
    return {
        /**
         * Wszystkie uprawnienia w kolejności menu, z polską nazwą i kategorią. Tylko dla roli ADMIN. 
         * @summary Katalog uprawnień
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionDefinitionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdministrationApi.getAdminPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Każda rola z jej uprawnieniami i liczbą osób. ADMIN ma zawsze komplet i nie da się go edytować. Tylko dla roli ADMIN. 
         * @summary Uprawnienia ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleAccessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdministrationApi.getAdminRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wszystkie konta poza systemowym: rola, aktywność, dodatkowe i efektywne uprawnienia. Tylko dla roli ADMIN. 
         * @summary Dostęp użytkowników
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAccessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdministrationApi.getAdminUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pełna podmiana uprawnień roli. Rola ADMIN → 400. Tylko dla roli ADMIN. 
         * @summary Podmiana uprawnień roli
         * @param {UserRoleDto} role 
         * @param {UpdateRolePermissionsRequestDto} updateRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminRolePermissions(role: UserRoleDto, updateRolePermissionsRequestDto: UpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminRolePermissions(role, updateRolePermissionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdministrationApi.updateAdminRolePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pełna podmiana roli, aktywności i dodatkowych uprawnień konta. Nie można zdjąć sobie roli ADMIN ani dezaktywować własnego konta (400); konto systemowe → 400; brak konta → 404. Tylko dla roli ADMIN. 
         * @summary Podmiana dostępu użytkownika
         * @param {string} userId 
         * @param {UpdateUserAccessRequestDto} updateUserAccessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminUserAccess(userId: string, updateUserAccessRequestDto: UpdateUserAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminUserAccess(userId, updateUserAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdministrationApi.updateAdminUserAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAdministrationApi - factory interface
 */
export const RestAdministrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAdministrationApiFp(configuration)
    return {
        /**
         * Wszystkie uprawnienia w kolejności menu, z polską nazwą i kategorią. Tylko dla roli ADMIN. 
         * @summary Katalog uprawnień
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionDefinitionDto>> {
            return localVarFp.getAdminPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Każda rola z jej uprawnieniami i liczbą osób. ADMIN ma zawsze komplet i nie da się go edytować. Tylko dla roli ADMIN. 
         * @summary Uprawnienia ról
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleAccessDto>> {
            return localVarFp.getAdminRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Wszystkie konta poza systemowym: rola, aktywność, dodatkowe i efektywne uprawnienia. Tylko dla roli ADMIN. 
         * @summary Dostęp użytkowników
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserAccessDto>> {
            return localVarFp.getAdminUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Pełna podmiana uprawnień roli. Rola ADMIN → 400. Tylko dla roli ADMIN. 
         * @summary Podmiana uprawnień roli
         * @param {UserRoleDto} role 
         * @param {UpdateRolePermissionsRequestDto} updateRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminRolePermissions(role: UserRoleDto, updateRolePermissionsRequestDto: UpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAdminRolePermissions(role, updateRolePermissionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Pełna podmiana roli, aktywności i dodatkowych uprawnień konta. Nie można zdjąć sobie roli ADMIN ani dezaktywować własnego konta (400); konto systemowe → 400; brak konta → 404. Tylko dla roli ADMIN. 
         * @summary Podmiana dostępu użytkownika
         * @param {string} userId 
         * @param {UpdateUserAccessRequestDto} updateUserAccessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminUserAccess(userId: string, updateUserAccessRequestDto: UpdateUserAccessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAdminUserAccess(userId, updateUserAccessRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAdministrationApi - interface
 */
export interface RestAdministrationApiInterface {
    /**
     * Wszystkie uprawnienia w kolejności menu, z polską nazwą i kategorią. Tylko dla roli ADMIN. 
     * @summary Katalog uprawnień
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionDefinitionDto>>;

    /**
     * Każda rola z jej uprawnieniami i liczbą osób. ADMIN ma zawsze komplet i nie da się go edytować. Tylko dla roli ADMIN. 
     * @summary Uprawnienia ról
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleAccessDto>>;

    /**
     * Wszystkie konta poza systemowym: rola, aktywność, dodatkowe i efektywne uprawnienia. Tylko dla roli ADMIN. 
     * @summary Dostęp użytkowników
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserAccessDto>>;

    /**
     * Pełna podmiana uprawnień roli. Rola ADMIN → 400. Tylko dla roli ADMIN. 
     * @summary Podmiana uprawnień roli
     * @param {UserRoleDto} role 
     * @param {UpdateRolePermissionsRequestDto} updateRolePermissionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAdminRolePermissions(role: UserRoleDto, updateRolePermissionsRequestDto: UpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Pełna podmiana roli, aktywności i dodatkowych uprawnień konta. Nie można zdjąć sobie roli ADMIN ani dezaktywować własnego konta (400); konto systemowe → 400; brak konta → 404. Tylko dla roli ADMIN. 
     * @summary Podmiana dostępu użytkownika
     * @param {string} userId 
     * @param {UpdateUserAccessRequestDto} updateUserAccessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAdminUserAccess(userId: string, updateUserAccessRequestDto: UpdateUserAccessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestAdministrationApi - object-oriented interface
 */
export class RestAdministrationApi extends BaseAPI implements RestAdministrationApiInterface {
    /**
     * Wszystkie uprawnienia w kolejności menu, z polską nazwą i kategorią. Tylko dla roli ADMIN. 
     * @summary Katalog uprawnień
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdminPermissions(options?: RawAxiosRequestConfig) {
        return RestAdministrationApiFp(this.configuration).getAdminPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Każda rola z jej uprawnieniami i liczbą osób. ADMIN ma zawsze komplet i nie da się go edytować. Tylko dla roli ADMIN. 
     * @summary Uprawnienia ról
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdminRoles(options?: RawAxiosRequestConfig) {
        return RestAdministrationApiFp(this.configuration).getAdminRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wszystkie konta poza systemowym: rola, aktywność, dodatkowe i efektywne uprawnienia. Tylko dla roli ADMIN. 
     * @summary Dostęp użytkowników
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdminUsers(options?: RawAxiosRequestConfig) {
        return RestAdministrationApiFp(this.configuration).getAdminUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pełna podmiana uprawnień roli. Rola ADMIN → 400. Tylko dla roli ADMIN. 
     * @summary Podmiana uprawnień roli
     * @param {UserRoleDto} role 
     * @param {UpdateRolePermissionsRequestDto} updateRolePermissionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAdminRolePermissions(role: UserRoleDto, updateRolePermissionsRequestDto: UpdateRolePermissionsRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdministrationApiFp(this.configuration).updateAdminRolePermissions(role, updateRolePermissionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pełna podmiana roli, aktywności i dodatkowych uprawnień konta. Nie można zdjąć sobie roli ADMIN ani dezaktywować własnego konta (400); konto systemowe → 400; brak konta → 404. Tylko dla roli ADMIN. 
     * @summary Podmiana dostępu użytkownika
     * @param {string} userId 
     * @param {UpdateUserAccessRequestDto} updateUserAccessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAdminUserAccess(userId: string, updateUserAccessRequestDto: UpdateUserAccessRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdministrationApiFp(this.configuration).updateAdminUserAccess(userId, updateUserAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

